// src/pages/fourd/FourDLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";

const sections = [
  {
    title: "4D 시뮬레이션",
    items: [
      {
        to: "",
        label: "4D 시뮬레이션 보기",
        end: true, // index 라우트 (/project/:id/fourd)
      },
      {
        to: "upload",
        label: "4D 시뮬레이션 업로드",
        end: true, // (/project/:id/fourd/upload)
      },
    ],
  },
];

const FourDLayout = () => {
  return (
    <SidebarLayout
      title="4D"
      base={(id) => `/project/${id}/4D`}
      sections={sections}
    >
      <Outlet />
    </SidebarLayout>
  );
};

export default FourDLayout;
